import React from 'react';

const TrackingPhoneIcon = ({ className = '' }: { className?: string }) => (
  <svg
    width="16"
    height="17"
    viewBox="0 0 16 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M14 13.1667V12.0694C14 11.5242 13.6681 11.0339 13.1619 10.8314L11.8058 10.289C11.1619 10.0314 10.4281 10.3104 10.118 10.9307L10 11.1667C10 11.1667 8.33333 10.8333 7 9.5C5.66667 8.16667 5.33333 6.5 5.33333 6.5L5.56934 6.38199C6.18959 6.07187 6.46857 5.33809 6.21103 4.69424L5.66859 3.33815C5.46611 2.83194 4.97583 2.5 4.43062 2.5H3.33333C2.59695 2.5 2 3.09695 2 3.83333C2 9.72437 6.77563 14.5 12.6667 14.5C13.403 14.5 14 13.903 14 13.1667Z"
      stroke="currentColor"
      strokeLinejoin="round"
    />
  </svg>
);

export default TrackingPhoneIcon;
